const notificationType = {
    INBOX : 'Inbox',
    SMS : 'Sms',
    VOICE : 'Voice',
    EMAIl : 'Email'
  }
  // this object for a notification logs filter in inbox table
  const ruleTypesNotificationLogs = [
    { label: 'On Boarding', value: "OnBoarding" },
    { label: 'Off Boarding', value: "OffBoarding" },
    { label: 'Reminder', value: "Reminder" },
    { label: 'Time Adherence', value: "Time Adherence" },
    { label: 'Vitals', value: "Vitals" },
    { label: 'Adherence', value: "Adherence" },
    { label: 'Weight', value: "Weight" },
    { label: 'Trending Violation', value: "Trending Violation" },
    { label: 'Event Expectation', value: "Event Expectation" },
  ]
  
  const months = [
    { label: 'January', value: "1" },
    { label: 'February', value: "2" },
    { label: 'March', value: "3" },
    { label: 'April', value: "4" },
    { label: 'May', value: "5" },
    { label: 'June', value: "6" },
    { label: 'July', value: "7" },
    { label: 'August', value: "8" },
    { label: 'September', value: "9" },
    { label: 'October', value: "10" },
    { label: 'November', value: "11" },
    { label: 'December', value: "12" }
  ]
  
  const years = []
  const currentYear = new Date().getFullYear();
  for (let year = currentYear; year >= 2020; year--) {
    years.push({ value: year, label: year.toString() });
  }

  const adminReportType = [
    { label: 'Select a Report', value: '' },
    { label: 'End of Month Report', value: '1' },
    { label: 'Notifications & Messages', value: '2' },
    { label: 'Version Report (Mobile App)', value: '3' }
  ]
  
  const dataConditions = [
    { label: 'Greater Than or Equal To', value: '>=' },
    { label: 'Less Than or Equal To', value: '<=' },
    { label: 'Between', value: 'between' },
    // { label: 'Not Between', value: 'notBetween' }
  ]

  // allow notification type
  const allowNotificationType = {
    SMS: 'Sms',
    EMAIl: 'Email',
    VOICE: 'Voice'
  }

  const primaryInsuranceProviders = [
    { value: "", label: 'None' },
    { value: "AETNA", label: 'AETNA' },
    { value: "CIGNA", label: 'CIGNA' },
    { value: "FHCP", label: 'FHCP' },
    { value: "HUMANA", label: 'HUMANA' },
    { value: "MEDICARE", label: 'MEDICARE' },
    { value: "TRICARE", label: 'TRICARE' },
    { value: "UNITED", label: 'UNITED' },
    { value: "UMR UNITED", label: 'UMR UNITED' },
    { value: "HEALTH FIRST", label: 'HEALTH FIRST' },
    { value: "WELL MED", label: 'WELL MED' },
    { value: "BLUE CROSS BLUE SHIELD", label: 'BLUE CROSS BLUE SHIELD' },
    { value: "FLORIDA BLUE", label: 'FLORIDA BLUE' },
    { value: "DEVOTED HEALTH", label: 'DEVOTED HEALTH' },
    { value: "CARE PLUS", label: 'CARE PLUS' },
    { value: "WELL CARE", label: 'WELL CARE' },
    { value: "FLORIDA HEALTHCARE PLANS", label: 'FLORIDA HEALTHCARE PLANS' },
    { value: "OTHER", label: 'OTHER' }
  ]
  const patientsTab = {
    all : 'ALL',
    active : 'ACTIVE',
    demo : 'DEMO',
    inActive : 'IN_ACTIVE',
    cellurConnectivity : 'CELLUR_CONNENCTIVITY',
    needToFollowUp : 'NEED_TO_FOLLOW_UP',
    hospitalAdmission : 'HOSPITAL_ADMISSION',
    itIssue : 'IT_ISSUE',
    followUpReminders : 'FOLLOW_UP_REMINDERS',
    reminderSent : 'REMINDER_SENT',
    didNotQualifyLastMonth : 'DID_NOT_QUALIFY_LAST_MONTH',
    monthlyCheckInPhoneCall : 'MONTHLY_CHECK_IN_PHONE_CALL',
    followUpPhoneCall : 'FOLLOW_UP_PHONE_CALL',
    educationMaterial : 'EDUCATION_MATERIAL',
    winsPositiveOutcome : 'WINS_POSITIVE_OUTCOME',
    rpmCarePlan : 'RPM_CARE_PLAN',
  }
  const userStatus = [
    { label: 'Select a user status', value: '' },
    { value: "true", label: 'Active' },
    { value: "false", label: 'In Active' }
  ]
  const appStatus = [
    { label: 'Select a app status', value: '' },
    { value: 'New', label: 'New' },
    { value: 'Old', label: 'Old' }
  ]
  const devicePlatform = [
    { label: 'Select a platform', value: '' },
    { value: 'iOS', label: 'iOS' },
    { value: 'Android', label: 'Android' }
  ]
  const RPMOnBoardingCategory = [
   "64620873b1cebb9c4d5b70ea",
   "646208d0b1cebb9c4d5b70eb",
   "64f02ecb6d9efff481a93e67",
   "646208d3b1cebb9c4d5b70ec",
   "646208d6b1cebb9c4d5b70ed"
  ]
  const EHR_RPMOnBoardingCategory = [
    "673b0cc0ddc94130af8d513c",
    "6911b697c4084353e779ac5c",
    "6911b7dfc4084353e779ac5e",
    "673b0d0295dac2bd8a709055",
    "675c171c95826b52e5e689ec",
    "675c1a1295826b52e5e689ed",
    "673b0d7cddc94130af8d513e",
  ]
  const CCMOnBoardingCategory = [
    "65081c5b4e8e9173654eb40b",
    "65081cba4e8e9173654eb40c",
    "650a77061e37821fe76376dc",
  ]
  const RPMOffBoardingCategory = [
    "64620ebdb1cebb9c4d5b70f7",
    "667aa0e00bc7bcfe6b65aa0e",
    "64c781a345daedcb3562a359",
    "64c781b245daedcb3562a35a",
    "6705158ac1d421c2143a8632"
  ]

  const subjectOptionsList = [
    {value:"Adherence Request", label : "Adherence Request"},
    {value:"RPM Session", label : "RPM Session"},
    {value:"CCM Session", label : "CCM Session"},
    {value:"Patient Education", label : "Patient Education"},
    {value:"Need To Follow Up", label : "Need To Follow Up"},
    {value:"Follow Up Reminder", label : "Follow Up Reminder"},
    {value:"Follow Up Phone Call", label : "Follow Up Phone Call"},
    {value:"Monthly Phone Call - Left Voicemail", label : "Monthly Phone Call - Left Voicemail"},
    {value:"Need To Follow Up Completed", label : "Need To Follow Up Completed"},
    {value:"Patient was recently admitted to the Hospital", label : "Patient was recently admitted to the Hospital"},
    {value:"IT Issues", label : "IT Issues"},
    {value:"WINS - Positive Outcome", label : "WINS - Positive Outcome"},
    {value:"Other", label : "Other"}
  ]
  // User status definitions
  const USER_STATUS = {
  APPROVED: 'Approved',
  };

  // follow phone call default message
  const phoneCallReminderMessage = {
    oneDayRemindMessgae : "Hello ${Patient Name}, this is a reminder for our phone call scheduled ${time}. Please call me if you need to reschedule at 321.765.6314. Thanks, ${Staff Name} from ${Organization}.",
    oneHourRemindMessgae : "Hello ${Patient Name}, this is a reminder for our phone call scheduled ${time}. Please call me if you need to reschedule at 321.765.6314. Thanks, ${Staff Name} from ${Organization}.",
    reminderEightAmUtcTodayMessage : "Hello ${Staff Name}, this is a reminder for the phone call scheduled with ${Patient Name} ${Patient Phone Number} ${time}. Please be prepared for the call. Thanks, My Vital View.",
    atTheTimeRemindMessage : "Hello ${Staff Name}, this is a reminder for the phone call scheduled with ${Patient Name} ${Patient Phone Number} ${time}. Please be prepared for the call. Thanks, My Vital View."
  }

  const isValidURL = (url) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' +                      // protocol
    '((([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,})|' +  // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' +            // OR IP (v4) address
    '(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$', 
    'i'
  );
  return pattern.test(url);
};

  const getFileIconClass = (filename) => {
  const extension = filename.split(".").pop().toLowerCase();

  if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension)) {
    return { icon: "mdi mdi-file-image", color: "#007bff" }; // Blue for image
  } else if (extension === "pdf") {
    return { icon: "mdi mdi-file-pdf", color: "red" };
  } else if (["doc", "docx"].includes(extension)) {
    return { icon: "mdi mdi-file-word", color: "#2b579a" }; // Word icon blue
  } else if (["xls", "xlsx", "csv"].includes(extension)) {
    return { icon: "mdi mdi-file-excel", color: "#217346" }; // Excel icon green
  } else {
    return { icon: "mdi mdi-file", color: "#6c757d" }; // Default grey file
  }
  };

  // Monthly Phone Call - Left Voicemail (unsuccessful monthly consultation attempt)
  const MonthlyPhoneCallLeftMessage = {
    subject : "Monthly Phone Call - Left Voicemail",
    message : "Reviewed patient's recent vitals, as well as their exceptions, events and adherence to provider's testing regiment. I tried calling the patient for their monthly phone consultation, but they did not answer. I left a voicemail and offered the patient to call or text us a time that is convenient for them."
  }

  // time zone list
  const allowedTimezones = {
      "America/New_York": "Eastern Time UTC-05",
      "America/Chicago": "Central Time UTC-06",
      "America/Denver": "Mountain Time UTC-07",
      "America/Los_Angeles": "Pacific Time UTC-08",
      "America/Anchorage": "Alaska Time UTC-09",
      "Pacific/Honolulu": "Hawaii UTC-10",
  };

  const filteredTimezones = Object.entries(allowedTimezones).map(([tz, label]) => ({
    label: `${tz} - ${label}`,
    value: tz,
  }));

const ExtremeBloodPressureReadingMessage = {
  extremeReadingPatient: `One of the values received in your last Blood Pressure measurement was considered in the Caution High or Low range. Please relax, wait a few minutes and perform another Blood Pressure measurement. Please make sure your cuff is on correctly and you are seated without crossing your legs. If you have any questions or concerns about your device, please call My Vital View at 321.765.6314. If you have any clinical questions please call your Provider office. Thank you.`,
  extremeReadingCareProvider: `One of the values received in your Patient’s recent Blood Pressure measurements was categorized as an Event. We sent a message for the patient to relax, wait a few minutes and perform another Blood Pressure measurement. One of the values received in their last Blood Pressure measurement was also categorized as an Event. Please review the Patient’s recent Blood Pressure measurements. Thank you.`,
  extremeReadingOneHourCareProvider: `One of the values received in your Patient’s recent Blood Pressure measurements was categorized as an Event. We sent a message for the patient to relax, wait a few minutes and perform another Blood Pressure measurement. Unfortunately we did not receive another Blood Pressure measurement from the patient within the last hour to confirm. Please review the Patient’s recent Blood Pressure measurements. Thank you.`,
}
const ExtremeGlucoseReadingMessage = {
  extremeReadingPatient: "One of the values received in your last Glucose measurement was considered in the Caution High or Low range. Please relax, wait a few minutes, and perform another Glucose measurement. Ensure your hands are clean and dry, and that you are following the correct procedure for your glucose testing device. If you have any questions or concerns about your device, please call My Vital View at 321.765.6314. If you have any clinical questions, please call your Provider office. Thank you.",
  extremeReadingCareProvider: "One of the values received in your Patient’s recent Glucose measurements was categorized as an Event. We sent a message for the patient to relax, wait a few minutes, and perform another Glucose measurement. One of the values received in their last Glucose measurement was also categorized as an Event. Please review the Patient’s recent Glucose measurements. Thank you.",
  extremeReadingOneHourCareProvider: "One of the values received in your Patient’s recent Glucose measurements was categorized as an Event. We sent a message for the patient to relax, wait a few minutes, and perform another Glucose measurement. Unfortunately, we did not receive another Glucose measurement from the patient within the last hour to confirm. Please review the Patient’s recent Glucose measurements. Thank you.",
}
const ExtremeWeightReadingMessage = {
  extremeReadingPatient: "One of the values received in your last Body Weight measurement indicated a potential weight loss concern. Please relax, wait a few minutes, and perform another weight measurement to confirm accuracy. Ensure your scale is on a flat, hard surface and you are weighing yourself under consistent conditions (same time of day, similar clothing). If you have any questions or concerns about your device, please call My Vital View at 321.765.6314. If you have any clinical questions, please call your Provider office. Thank you.",
  extremeReadingCareProvider: "One of the values received in your Patient’s recent Body Weight measurements was categorized as an Event. A message was sent to the patient advising them to relax, wait a few minutes, and perform another weight measurement. However, the value received in their most recent Body Weight measurement was also categorized as an Event. Please review the Patient’s recent Body Weight measurements. Thank you.",
  extremeReadingOneHourCareProvider: "One of the values received in your Patient’s recent Body Weight measurements was categorized as an Event. We sent a message for the patient to relax, wait a few minutes, and perform another weight measurement. Unfortunately, we did not receive another Body Weight measurement from the patient within the last hour to confirm. Please review the Patient’s recent Body Weight measurements. Thank you.",
     
}
const ExtremeOxigenReadingMessage = {
  extremeReadingPatient: "One of the values received in your last Oxygen Saturation measurement was considered in the Caution High or Low range. Please relax, wait a few minutes, and perform another Oxygen Saturation measurement. Ensure your finger is clean, warm, and properly placed in the pulse oximeter according to the device instructions. If you have any questions or concerns about your device, please call My Vital View at 321.765.6314. If you have any clinical questions, please call your Provider office. Thank you.",
  extremeReadingCareProvider: "One of the values received in your Patient’s recent Oxygen Saturation measurements was categorized as an Event. We sent a message for the patient to relax, wait a few minutes, and perform another Oxygen Saturation measurement. However, one of the values received in their most recent Oxygen Saturation measurement was also categorized as an Event. Please review the Patient’s recent Oxygen Saturation measurements. Thank you.",
  extremeReadingOneHourCareProvider: "One of the values received in your Patient’s recent Oxygen Saturation measurements was categorized as an Event. We sent a message for the patient to relax, wait a few minutes, and perform another Oxygen Saturation measurement. Unfortunately, we did not receive another Oxygen Saturation measurement from the patient within the last hour to confirm. Please review the Patient’s recent Oxygen Saturation measurements. Thank you.",
}

const ScheduledAndUnScheduledId = {
  unScheduled : "6911b7dfc4084353e779ac5e",
  scheduled : "6911b697c4084353e779ac5c"
}

  // Careprovider subject selection
  const Careprovider_EHR_RPMOnBoardingCategory = [
    "6911b697c4084353e779ac5c",
    "6911b7dfc4084353e779ac5e",
  ]

  const Careprovider_SubjectOptionsList = [
    {value:"Adherence Request", label : "Adherence Request"},
    {value:"RPM Session", label : "RPM Session"},
    {value:"CCM Session", label : "CCM Session"},
    {value:"Patient Education", label : "Patient Education"},
    {value:"Need To Follow Up", label : "Need To Follow Up"},
    {value:"Follow Up Reminder", label : "Follow Up Reminder"},
    {value:"Follow Up Phone Call", label : "Follow Up Phone Call"},
    {value:"Need To Follow Up Completed", label : "Need To Follow Up Completed"},
    {value:"Monthly Check in Phone Call", label : "Monthly Check in Phone Call"},
    {value:"Monthly Phone Call - Left Voicemail", label : "Monthly Phone Call - Left Voicemail"},
    {value:"WINS - Positive Outcome", label : "WINS - Positive Outcome"},
    {value:"Other", label : "Other"}
  ]

  const Staff_SubjectOptionsList = [
    {value:"Adherence Request", label : "Adherence Request"},
    {value:"RPM Session", label : "RPM Session"},
    {value:"CCM Session", label : "CCM Session"},
    {value:"Patient Education", label : "Patient Education"},
    {value:"Need To Follow Up", label : "Need To Follow Up"},
    {value:"Follow Up Reminder", label : "Follow Up Reminder"},
    {value:"Follow Up Phone Call", label : "Follow Up Phone Call"},
    {value:"Need To Follow Up Completed", label : "Need To Follow Up Completed"},
    {value:"Monthly Check in Phone Call", label : "Monthly Check in Phone Call"},
    {value:"Monthly Phone Call - Left Voicemail", label : "Monthly Phone Call - Left Voicemail"},
    {value:"Patient was recently admitted to the Hospital", label : "Patient was recently admitted to the Hospital"},
    {value:"WINS - Positive Outcome", label : "WINS - Positive Outcome"},
    {value:"Other", label : "Other"}
  ]

  // appointment status
  const AppointmentStatus = {
    appointmentScheduled : 'Appointment Scheduled',
    appointmentCompleted : 'Appointment Completed'
  }


const ScheduledAndUnScheduledSubject = {
  unScheduled : "EHR RPM ONB – No Scheduled Appointment (Device Pickup & Training)",
  scheduled : "EHR RPM ONB - Scheduled Appointments",
  monthlyCheckCall : "Monthly Check in Phone Call",
  followUpPhoneCall : "Follow Up Phone Call",
}

  const enrolledPrograms = [
    { value: "", label: "Select Enrolled Program" },
    { value: "CCM", label: "CCM" },
    { value: "RPM", label: "RPM" },
    { value: "CCM&RPM", label: "CCM&RPM" }
  ]

  const deviceType = {
    desktop: 'desktop',
    mobile: 'mobile',
    tablet: 'tablet'
  }

  module.exports = {
    notificationType,
    ruleTypesNotificationLogs,
    months, 
    years,
    adminReportType,
    dataConditions,
    primaryInsuranceProviders,
    patientsTab,
    allowNotificationType,
    userStatus,
    devicePlatform,
    appStatus,
    subjectOptionsList,
    RPMOnBoardingCategory,
    EHR_RPMOnBoardingCategory,
    CCMOnBoardingCategory,
    RPMOffBoardingCategory,
    USER_STATUS,
    phoneCallReminderMessage,
    isValidURL,
    getFileIconClass,
    MonthlyPhoneCallLeftMessage,
    filteredTimezones,
    ExtremeBloodPressureReadingMessage,
    ExtremeGlucoseReadingMessage,
    ExtremeWeightReadingMessage,
    ExtremeOxigenReadingMessage,
    ScheduledAndUnScheduledId,
    Careprovider_EHR_RPMOnBoardingCategory,
    Staff_SubjectOptionsList,
    Careprovider_SubjectOptionsList,
    AppointmentStatus,
    ScheduledAndUnScheduledSubject,
    enrolledPrograms,
    deviceType
  }
